// File: custom-transition.js
// Import Highway
import Highway from './highway';
import gsap from 'gsap'
import stage from '../components/stage'

class CustomTransition extends Highway.Transition {
  // Built-in methods

  in({ from, to, trigger, done }) {

         gsap.fromTo(to,
           {opacity: 0},
           {
            opacity: 1, duration: .71, ease: "power4.inOut",
            onComplete: ()=>{
                done()
                $('body').css({backgroundColor: to.dataset.bg || '#ffffff'})
            }
           }
         );
          window.scrollTo(0, 0);

         from.remove();

  }

  out({ from, trigger, done }) {

    //$('body').css({backgroundColor: from.dataset.color})

    gsap.to(from,.71,
      {
       opacity: 0,
       ease: "power2.out",
       onComplete: ()=>{
         done()
       }
      }
    );


  }
}

// Don`t forget to export your transition
export default CustomTransition;
